module.exports = __webpack_public_path__ + "static/media/CrossCheck_Cover.d020252f.jpg";